<app-sub-nav [menuItems]="menuItems"></app-sub-nav>
